<template>
  <div>
    <div class="pb-16 border-b border-light-gray-4">
      <div class="w-full">
        <span class="text-16">Keyword Search</span>

        <button @click="clearFilters" class="float-right normal-case text-orange py-4 text-12 float-right underline">
          Clear All
        </button>
      </div>
      <search-form class="ml-auto pt-20 pb-14 leading-none"
        placeholder="Type your search"
        @toggled="redirect"
        :default-value.sync="query.search"
        inputClass="rounded-md py-16 text-14 focus:outline-none">
        <template #icon="{ toggleSearch }">
          <div class="absolute right-0 center-y mr-12 cursor-pointer">
            <div class="px-10 py-8 text-white bg-orange rounded-md"
              @click="toggleSearch">
              <i class="far fa-search text-sm"></i>
            </div>
          </div>
        </template>
      </search-form>
    </div>

    <the-filter-desktop-items
        v-for="(filter, key) in filters"
        v-if="filter.options.length > 0"
        :key="key"
        :filter="filter"
        open
        class="py-22 filterBorder">
    </the-filter-desktop-items>
  </div>
</template>

<script>
import TheFilterDesktopItems from './TheFilterDesktopItems'
import SearchForm from './Universal/SearchForm.vue'
import { FILTERS } from '../support/constants'
import pick from 'lodash/pick'

export default {
  inject: {
    allFilters: 'filters',
    query: 'query',
    queryActions: 'queryActions',
  },

  components: {
    TheFilterDesktopItems,
    SearchForm,
  },

  methods: {
    clearFilters () {
      this.queryActions.clear()
      window.TheNavBarDesktop.clearSearch()
    },

    redirect(search) {
      this.queryActions.sync({search: search.term, page: 1})
    },
  },

  computed: {
    filters () {
      return pick(this.allFilters, FILTERS)
    },
  },
}
</script>

<style>
.filterBorder:not(:last-child) {
  border-bottom: 1px solid #E5E0DF;
}
</style>
